import * as Sentry from '@sentry/browser';
import { getVersion, isProd } from './env';

export const maybeSetupSentry = () => {
  if (!isProd()) return;
  Sentry.init({
    dsn: 'https://cdc2090723644c05bb4261a39ecbadf6@o399834.ingest.sentry.io/5257582',
    release: `tbs-client@${getVersion()}`,
  });
};
